export class ButtonItem {
  id;
  name;
  icon;

  constructor(id, name, icon = null, changeAction = null) {
    this.id = id;
    this.name = name;
    this.icon = icon;
  }
}
